import { all, fork } from "redux-saga/effects";
import { saga as authSaga } from "@containers/Auth/store";
import userSaga from "@containers/User/store/saga";
import sensorSaga from "@containers/Sensor/store/saga";
import patientSaga from "@containers/Patient/store/saga";
import sharedSaga from "@shared/store/saga";
import stationSaga from "@containers/Station/store/saga";
import hospitalSaga from "@containers/Hospital/store/saga";
import sensorDataFileSaga from "@containers/SensorDataFile/store/saga";
import sensorDataSessionSaga from "@containers/SensorDataSession/store/saga";
import SensorDataRestoringRequestSaga from "@containers/SensorDataRestoringRequest/store/saga";
import alertSaga from "@containers/Alert/store/saga";
import reportSaga from "@containers/Report/store/saga";

const allSagas = [
  authSaga,
  userSaga,
  sensorSaga,
  stationSaga,
  patientSaga,
  hospitalSaga,
  sharedSaga,
  sensorDataFileSaga,
  sensorDataSessionSaga,
  SensorDataRestoringRequestSaga,
  alertSaga,
  reportSaga,
];

export default function* appSagas() {
  yield all(allSagas.map(fork));
}
